module.exports = __webpack_public_path__ + "img/order-dispatched.2964384e.gif";